export default "__VITE_ASSET__CtHanKjg__"